module.exports = __webpack_public_path__ + "img/imgZXGH(30).ad00cf30.png";